import styled from 'styled-components';

export const Content = styled.div`
	background-color: #eee;
	padding: 20px;
	flex: 1;
	margin: 20px;
	width: 100%;

	@media (min-width: 768px) {
		width: 80%;
	}

	p {
		font-size: 1.05rem;
		font-weight: 300;
		margin-bottom: 10px;
		color: #333333;
	}
`;

export const Header = styled.h1`
	color: #2c354a;
	margin-bottom: 20px;
	font-size: 1.5rem;
	padding-right: 20px;
	span {
		font-size: 8pt;
	}
`;

export const CardsContainer = styled.div`
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	justify-content: flex-start;
	@media (max-width: 768px) {
		justify-content: center;
	}
`;
